(() => {
  if (customElements.get('deferred-shop-follow')) return;
  customElements.define('deferred-shop-follow', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded || this.observer) return;
      if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        this.activate();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.activate();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(this);
    }
    activate() {
      if (this.loaded) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.loaded = true;
      this.observer?.disconnect();
      this.observer = null;
      this.appendChild(document.importNode(template.content, true));
      template.remove();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  });
})();
